<template>
	<div>
		<div id="h-top">
			<div class="container fc-bet">
				<div class="top-left fc">
          <span v-if="userName">{{userName}}</span>
					<router-link to="login"  class="name" v-else>
						您好，请登录
					</router-link>
          &emsp;
					<a href="" class="out" v-if="userName" @click="doExit">
						退出
					</a>
					<div class="merchantSendCenter">
						<label class="control-label">天正电气</label>
<!--						<select name="" class="merchat-select">-->
<!--							<option value="">天正电气</option>-->
<!--						</select>-->
					</div>
				</div>
				<div class="top-right fc">
					<ul class="fc">
<!--						<li>-->
<!--							<a href="">下载中心</a>-->
<!--						</li>-->
<!--						<li class="line">|</li>-->
<!--						<li>-->
<!--							<a href="">我的消息</a>-->
<!--						</li>-->
<!--						<li class="line">|</li>-->
<!--						<li>-->
<!--							<router-link to="orders">我的订单</router-link>-->
<!--							-->
<!--						</li>-->
            <li class="line">
              <a target="_blank" href="https://zxapi.tengen.com.cn/console" >
              <p style="display: inline-block;color: #57aca7;">智选后台</p>
              </a>
            </li>
            <li class="line">|</li>
						<li class="line">
              <a target="_blank" href="https://dmc.tengen.com.cn/pcweb">
                <p style="display: inline-block;color: #57aca7;">DMC渠道云</p>
              </a>
            </li>
            <li class="line">|</li>
						<li>
							<router-link to="baseInfo">个人中心</router-link>

						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getUserInfo } from '@/api/login'
import { cartCount } from '@/api/cart'
import { mapGetters, mapMutations } from 'vuex'
import {
  clearUserInfo,
  clearUserSession,
  getStoredUserInfo,
  hasUserIdentity,
  refreshUserInfo,
  saveUserInfo
} from '@/utils/auth'
import { getToken } from '@/axios/cookies'
	export default {
    name: 'i-head-top',
		data() {

			return {
        userName:null,
        status: 0
			}
		},
    computed: {
      ...mapGetters({
        userInfo: 'userInfo', // 用户信息
        cartNum: 'cartNum' // 购物车商品数量
      })
    },
    watch: {
      userInfo: function(val) {
        console.log("val",val)
        console.log("val.id",val && val.id)
        if (hasUserIdentity(val)) {
          this.userName = val.name || val.nickname || null
          this.getCartNum()
        } else {
          this.userName = null
          this.setCartNum(0)
        }
      },
    },
		methods: {
      doExit(){
        clearUserSession()
      },
      ...mapMutations({
        setCartNum: 'SET_CARTNUM' // 修改购物车商品数量
      }),
      // 获取购物车商品数量
      async getCartNum () {
        const res = await cartCount()
        if (res.status === 200) {
          this.setCartNum(res.data.count)
        } else {
          this.$message.warning(res.msg)
        }
      },
      async loadUserInfo () {
        const res = await getUserInfo()
        if (res.status === 200) {
          const userInfo = refreshUserInfo(res.data)
          if (hasUserIdentity(userInfo)) {
            this.userName = userInfo.name || userInfo.nickname || null
            this.getCartNum()
          }
        }
      }
		},
		mounted() {
      const token = getToken()
      const userInfo = getStoredUserInfo()
      if (token && hasUserIdentity(userInfo)) {
        saveUserInfo(userInfo)
        this.userName = userInfo.name || userInfo.nickname || null
        this.getCartNum()
      } else if (token) {
        this.loadUserInfo()
      } else {
        clearUserInfo()
        this.userName = null
      }
		}

	}

  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?bb80d3a12f8c45fc611d1d4d61ffe339";
    var s = document.getElementsByTagName("script")[0]; 
    s.parentNode.insertBefore(hm, s);
  })();
</script>


